<template>
<!-- ====================== 페이지내 내용 ====================== 


-->
<div>
    <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >
        <v-toolbar-title>통계 검색옵션</v-toolbar-title>
        <v-spacer/>
    <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
        <v-btn
            color="blue-grey lighten-2"
            small
            fab
            v-bind="attrs"
            v-on="on"
        >
            <v-icon 
            color= ""
            >mdi-information-variant</v-icon>
        </v-btn>
    </template>
    최근 7일,30일,90일 검색에는 검색 당일이 포함됨니다.
    </v-tooltip>
    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <form
            class="pa-4">
            <v-radio-group
            v-model="app_ad"
            row
            >
            <v-radio
                label="전면광고"
                value="front"
            ></v-radio>
            <v-radio
                label="중간광고"
                value="mid"
            ></v-radio>
            <v-radio
                label="메인앱광고"
                value="main"
            ></v-radio>
            <v-radio
                label="종료앱광고"
                value="end"
            ></v-radio>
            </v-radio-group>

            <v-radio-group
            v-model="days"
            row
            >
            <v-radio
                label="오늘"
                :value="1"
            ></v-radio>
            <v-radio
                label="최근 7일"
                :value="7"
            ></v-radio>
            <v-radio
                label="최근 30일"
                :value="30"
            ></v-radio>
            <v-radio
                label="최근 90일"
                :value="90"
            ></v-radio>
            <v-radio
                label="직접 입력"
                value="custom"
            ></v-radio>
            </v-radio-group>


            <v-row>
                <v-col>
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date"
                            label="시작일 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            filled
                            outlined
                            dense
                            :disabled="days != 'custom' || date2 == ''"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="date"
                        no-title
                        scrollable
                        :max="date2"
                        @click:date="$refs.menu.save(date)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                    <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :return-value.sync="date2"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="date2"
                            label="종료일 선택"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :disabled="days != 'custom'"
                            filled
                            outlined
                            dense
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-if="menu2"
                        v-model="date2"
                        no-title
                        scrollable
                        :max="today"
                        :min="date"
                        @click:date="$refs.menu2.save(date2)"
                        >
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col>
                </v-col>
            </v-row>
            <v-btn
            class="mr-4"
            color="blue"
            @click="submit"
            :disabled="tempInfo[0]?false:true"
            >
            검색
            </v-btn>
        </form>
    </v-card>

        <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        color='#37474F'
        dark
    >
        <v-toolbar-title>DAY7 광고 통계</v-toolbar-title>
        <v-spacer/>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="검색"
            single-line
            hide-details
        ></v-text-field>
    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <v-data-table
            :headers="headers"
            :items="statisticsData"
            :single-select="false"
            item-key="name"
            :search="search"
            class="elevation-1"
            :loading="statisticsData[0]?false:true"
            loading-text="데이터를 가져오는 중입니다. 잠시만 기다려 주세요."
            hide-default-footer
            :items-per-page="-1"
        >
            <template v-slot:item.clickProb="{ item }">
                {{item.clickProb + '%'}}
            </template>
            <template v-slot:item.clickDownProb="{ item }">
                {{item.clickDownProb + '%'}}
            </template>
            <template v-slot:item.viewDownProb="{ item }">
                {{item.viewDownProb + '%'}}
            </template>
        </v-data-table>
    </v-card>

    <div class="py-3"></div>
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        search:'',
        today: moment().format('YYYY-MM-DD'),
        subDate:'',
        tempInfo:[moment().format('YYYY-MM-DD')],
        app_ad:'front',
        days:1,
        menu: false,
        menu2:false,
        date:"",
        date2:"",
        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        statisticsData:[],
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        viewCount:'노출수',
        clickCount:'클릭수',
        downCount:'다운수',
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록
        /*
        headers: [            
            { text: '게임명', value: 'appName', sortable: false },
            { text: '노출수', value: 'viewCount', sortable: true, width:200  },
            { text: '클릭수', value: 'clickCount', sortable: true, width:200 },
            { text: '다운수', value: 'downCount', sortable: true, width:200 },
            { text: '클릭률%', value: 'clickProb', sortable: true, width:150 },
            { text: '클릭다운률%', value: 'clickDownProb', sortable: true, width:150 },
            { text: '노출다운률%', value: 'viewDownProb', sortable: true, width:150 },
        ],
        */
        event_history_all:[           
        ]
    }),

    created()
    {
        this.getStatisticsData()
    },

    methods:{
        ...mapActions([
            'GET_LOG_TODAY',
            'GET_LOG',
            'GET_STATISTICS_DATA'
        ]),
        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
         OnSearch_Event()
        {
            console.log('이벤트 등록하기');//GET_LOG_TODAY 
            let log_type = 'REGIST';
            this.event_history_all = [];
            //console.log(log_type);
            //start_date, end_date
            let start_date = this.start_date;
            let end_date = this.end_date;
            this.GET_LOG({log_type , start_date, end_date}).then((body_data)=>{
                console.log("GET_LOG"+JSON.stringify(body_data));
                
                let event_info = body_data.event_info;
                let remake_eventInfo ={};// event_info[]
                for(let index in event_info)
                {   
                    remake_eventInfo[event_info[index].event_tag] = event_info[index];
                }
                console.log(JSON.stringify(remake_eventInfo));
                let result = body_data.result;
                for(let index in result)
                {
                    let reportItem = result[index];
                    let eventInfo = remake_eventInfo[reportItem.event_tag];
                    if(eventInfo != undefined)
                    {
                        let event_item = {};
                        event_item['event_tag'] = eventInfo.event_tag;
                        event_item['event_name'] = eventInfo.event_name;
                        event_item['package'] = eventInfo.package;
                        event_item['count'] = reportItem.count;
                        
                        this.event_history_all.push(event_item);
                        console.log(JSON.stringify(reportItem));
                    }
                }
                console.log(JSON.stringify(this.event_history_all));
            });
        },
        OnSearch_Event_Today()
        {//오늘자로만 검색해서 가져오도록 한다                              
            let log_type = 'REGIST';
            this.event_history_all = [];
            console.log(log_type);
            this.GET_LOG_TODAY({log_type}).then((body_data)=>{
                console.log("ADD_LOG_EVENT"+JSON.stringify(body_data));
                
                let event_info = body_data.event_info;
                let remake_eventInfo ={};// event_info[]
                for(let index in event_info)
                {   
                    remake_eventInfo[event_info[index].event_tag] = event_info[index];
                }
                console.log(JSON.stringify(remake_eventInfo));
                let result = body_data.result;
                for(let index in result)
                {
                    let reportItem = result[index];
                    let eventInfo = remake_eventInfo[reportItem.event_tag];
                    if(eventInfo != undefined)
                    {
                        let event_item = {};
                        event_item['event_tag'] = eventInfo.event_tag;
                        event_item['event_name'] = eventInfo.event_name;
                        event_item['package'] = eventInfo.package;
                        event_item['count'] = reportItem.count;
                        
                        this.event_history_all.push(event_item);
                        console.log(JSON.stringify(reportItem));
                    }
                }
                console.log(JSON.stringify(this.event_history_all));
            });
        },
        DownloadData_Csv()
        {
            console.log('이벤트 다운로드 하기 ');
        },
        async getStatisticsData(){
            console.log('통계 데이터 가져오기 함수 실행됨')
            // 변수 수정 필요
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            const app_ad = this.app_ad
            const tempInfo = this.tempInfo
            // 수정 필요
            this.statisticsData = Object.values(await this.GET_STATISTICS_DATA({selected_ad_os,selected_ad_language,app_ad,tempInfo}))
            console.log('받아온 데이터',this.statisticsData)
        },
        submit(){
            console.log('통계 데이터 가져오기 실행')
            this.statisticsData = []
            this.getStatisticsData()
        },
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : ''
        },
        osForWatch () {
            return store.state.selected_ad_os
        },
        langeageForWatch () {
            return store.state.selected_ad_language
        },
        // 받아온 배열상에서 각 해당하는 내용들을 다 더해서 반환해줘야 한다.
        // 배열 메서드 reduce 를 사용한다.
        totalViewCount () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + c.viewCount
            }, 0).toLocaleString()})`:''
        },
        totalClickCount () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + c.clickCount
            }, 0).toLocaleString()})`:''
        },
        totalDownCount () {
            return this.statisticsData[0]?`(${this.statisticsData.reduce((p, c, i, a) => {
                return p + c.downCount
            }, 0).toLocaleString()})`:''
        },
        headers () {
            return [            
            { text: '게임명', value: 'appName', sortable: false },
            { text: `노출수 ${this.totalViewCount}`, value: 'viewCount', sortable: true, width:170  },
            { text: `클릭수 ${this.totalClickCount}`, value: 'clickCount', sortable: true, width:170 },
            { text: `다운수 ${this.totalDownCount}`, value: 'downCount', sortable: true, width:170 },
            { text: '클릭률%', value: 'clickProb', sortable: true, width:150 },
            { text: '클릭다운률%', value: 'clickDownProb', sortable: true, width:150 },
            { text: '노출다운률%', value: 'viewDownProb', sortable: true, width:150 },
        ]
        },
    },
    components:{
    },
    watch :{
        date: function() {
                console.log('date watch 실행됨')
                if(this.date != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                console.log(this.subDate)
                console.log(moment(this.date2))
                console.log(this.subDate <= moment(this.date2))
                while ( this.subDate <= moment(this.date2)){
                    console.log(this.subDate)
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
            }
            this.subDate = ''
        },
        date2: function() {
            console.log('date2 watch 실행됨')
            if(this.date2 != ''){
                this.tempInfo = []
                this.subDate = moment(this.date)
                while ( this.subDate <= moment(this.date2)){
                    console.log(this.subDate)
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
            }
            this.subDate = ''
        },
        days: function() {
            this.date = ''
            this.date2 = ''
            console.log('days watch 실행됨')
            if(this.days != 'custom'){
                console.log('costom 아님 분기')
                this.tempInfo = []
                this.subDate = moment(moment().format('YYYY-MM-DD')).subtract(this.days - 1,'days')
                while ( this.subDate <= moment(moment().format('YYYY-MM-DD'))){
                    console.log(this.subDate)
                    this.tempInfo.push( this.subDate.format('YYYY-MM-DD'))
                    this.subDate = this.subDate.add(1,'days')
                }
                this.subDate = ''
            } else {
                console.log('costom 맞음 분기')
                this.tempInfo = []
                this.subDate = ''
            }

        },
        osForWatch: function() {
            this.submit()
        },
        langeageForWatch: function() {
            this.submit()
        },
    },

};
</script>
